export const DISPATCH_REQUEST = "DISPATCH_REQUEST";
export const DISPATCH_SUCCESS = "DISPATCH_SUCCESS";
export const DISPATCH_FAILED = "DISPATCH_FAILED";
export const DISPATCH_APPROVAL_REQUEST = "DISPATCH_APPROVAL_REQUEST"
export const DISPATCH_APPROVAL_SUCCESS = "DISPATCH_APPROVAL_SUCCESS";
export const DISPATCH_APPROVAL_FAILED = "DISPATCH_APPROVAL_FAILED";
